import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type ApiPaymentSetupInput, type SugarResponse } from '@app/types'
import { useMutation } from '@tanstack/react-query'

export const usePaymentSetup = () => {
  const { siteId } = useSugarContext()

  return useMutation({
    mutationKey: ['paymentSetup'],
    mutationFn: async (paymentSetupInput: ApiPaymentSetupInput) => {
      const { data } = await apiClient.post<SugarResponse<never>>(
        '/api/payment-setup',
        {
          ...paymentSetupInput,
          siteId
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      return data
    }
  })
}
